import { render, staticRenderFns } from "./tipMessage.vue?vue&type=template&id=49cbc280&scoped=true"
import script from "./tipMessage.vue?vue&type=script&lang=js"
export * from "./tipMessage.vue?vue&type=script&lang=js"
import style0 from "./tipMessage.vue?vue&type=style&index=0&id=49cbc280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbc280",
  null
  
)

export default component.exports